// extracted by mini-css-extract-plugin
export default {"info_text":"styles_info_text__Q4U3o"};